// Navbar.js

import { Link } from "react-router-dom";
import { useState } from "react";
import SecondaryLogo from "../secondaryLogo/SecondaryLogo";

const Navbar = (props) => {
    const { productCategoryArray } = props;
    
    const [mobileNavbarShow, setMobileNavbarShow] = useState(false);

    const [dropDownMenu, setDropDownMenu] = useState(false);

    const handleMobileMenu = () => {
        setMobileNavbarShow(!mobileNavbarShow);
        // toggle state
    }

    const closeMobileNavbar = () => {
        setMobileNavbarShow(false);
    }

    const handleDropDownMenu = (event) => {
        event.preventDefault();
        setDropDownMenu(!dropDownMenu);
        // toggle state
    }

    const closeDropDown = () => {
        setDropDownMenu(false);
        // setting state to false when clicked on items in dropdown menu
    }

    // Function to sort categories
    const sortCategory = (a, b) => {
        // Keep 'sofas' and 'beds' at the beginning
        if (a.fields.name === 'beds') return -1;
        if (b.fields.name === 'beds') return 1;

        if (a.fields.name === 'sofas') return -1;
        if (b.fields.name === 'sofas') return 1;
        // Keep the original order for other categories
        return 0;
    };

    // Sort the categories array
    productCategoryArray.sort(sortCategory);
    
    const moreFurnitureCategory = [];

    const navProductCategoryArray = productCategoryArray.filter((category) => {
        if (category.fields.moreFurnitureCategory === true ) {
            moreFurnitureCategory.push(category);
            return null; // returning null for items to be moved
        }
        return category; // returning the original item for items to be kept
    }).filter(Boolean); // filter out null values
    
    return(
        <nav>
            {/* hamburger menu for mobile */}
            <div className={`navbar-mobile__hamburger ${mobileNavbarShow ? 'close' : ''}`} onClick={handleMobileMenu}>
            </div>

            <SecondaryLogo />

            <div className={`navbar-overlay ${mobileNavbarShow ? 'navbar-overlay__show' : ''}`} onClick={closeMobileNavbar}></div>
            
            <div className="navbar">
                <ul className={`navbar-main ${mobileNavbarShow ? 'navbar-mobile' : ''}`}>
                    {navProductCategoryArray.map((category) => {
                        return (
                            <li key={category.sys.id}>
                                <Link to={category.fields.name.replace(/\s+/g, '-').toLowerCase()} className="navbar-category" onClick={() => {closeMobileNavbar(); closeDropDown();}}>{category.fields.name.toUpperCase()}</Link>
                            </li>
                        )
                    })}

                    {/* dropdown for more furniture category */}
                    <li className="navbar-category__dropdown">
                        <Link to="more-furniture" className={`navbar-category ${dropDownMenu ? 'navbar-category__dropdown--open' : ''}`} onClick={handleDropDownMenu}>MORE FURNITURE <i className="fa-solid fa-chevron-down"></i></Link>
                        <ul className="navbar-category__dropdown--content">
                            {
                            moreFurnitureCategory.map((category) => {
                                // if (category.fields.name.toLowerCase() !== 'more furniture') {
                                    return (
                                        <li key={category.sys.id}>
                                            <Link to={`/more-furniture/${category.fields.name.replace(/\s+/g, '-').toLowerCase()}`} className="navbar-category navbar-category__dropdown--menu" onClick={() => {closeMobileNavbar(); closeDropDown();}}>{category.fields.name.toUpperCase()}</Link>
                                        </li>
                                    );
                                // } else {
                                //     return null;
                                // }
                            })
                            }
                        </ul>
                    </li>
                </ul>
            </div>
        </nav>
    )
}

export default Navbar;